import { render } from "./SectionLightness.vue?vue&type=template&id=15a619c8"
import script from "./SectionLightness.vue?vue&type=script&lang=js"
export * from "./SectionLightness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__